import React from "react";
import Celular from "../images/celular.png";
import Telefone from "../images/telefone.png";
import Chat from "../images/chat.png";
import Atendimento from "../images/atendimento.png";
import { useCartao } from "../hooks/cartao";

const Bloco2: React.FC = () => {
    const { passo } = useCartao();
    return (
        <>
            {passo === 0 && (
                <section className="bg-theme2">
                    <div className="container items-center px-5 py-2 lg:py-16 mx-auto lg:flex-row lg:px-18 lg:px-28">
                        <div className="mx-auto px-4 lg:px-0 w-full lg:w-5/6 py-8 -mt-96 bg-white border lg:border-2 border-gray-500 shadow-lg rounded-2xl">
                            <div className="w-1/4 mx-auto h-px lg:h-1 bg-gray-500"></div>
                            <h1 className=" w-full text-center mb-2 lg:mb-8 text-xl lg:text-3xl py-5 font-semibold tracking-tight mx-auto text-gray-500">
                                <b className="font-bold text-theme">
                                    Desbloqueie o cartão
                                </b>{" "}
                                de diversas formas:
                            </h1>

                            <div className="mx-auto my-10 lg:w-2/4 justify-center items-center flex flex-grow-0 text-left text-gray-600">
                                <div className="flex items-center w-1/4">
                                    <img
                                        className="mx-auto"
                                        alt="APP DENTAL UNI"
                                        src={Celular}
                                    />
                                </div>
                                <div className="w-3/4">
                                    <p className="leading-tight tracking-tight text-md lg:text-xl">
                                        <b>APP DENTAL UNI</b> - Baixe o
                                        aplicativo gratuito para smartphones nas
                                        versões iOS ou Android, faça login como
                                        beneficiário e clique em DESBLOQUEAR
                                        CARTÃO.
                                    </p>
                                </div>
                            </div>
                            <div className="mx-auto my-10 lg:w-2/4 justify-center items-center flex flex-grow-0 text-left text-gray-600">
                                <div className="flex items-center w-1/4">
                                    <img
                                        className="mx-auto"
                                        alt="SITE DENTAL UNI"
                                        src={Chat}
                                    />
                                </div>
                                <div className="w-3/4">
                                    <p className="leading-tight tracking-tight text-md lg:text-xl">
                                        <b>SITE DENTAL UNI</b> - Acesse
                                        www.dentaluni.com.br, faça login como
                                        beneficiário e clique em CARTÃO VIRTUAL
                                        E DESBLOQUEIO.
                                    </p>
                                </div>
                            </div>
                            <div className="mx-auto my-10 lg:w-2/4 justify-center items-center flex flex-grow-0 text-left text-gray-600">
                                <div className="flex items-center w-1/4">
                                    <img
                                        className="mx-auto"
                                        alt="SERVIÇO DE ATENDIMENTO AO BENEFICIÁRIO"
                                        src={Telefone}
                                    />
                                </div>
                                <div className="w-3/4">
                                    <p className="leading-tight tracking-tight text-md lg:text-xl">
                                        <b>
                                            SERVIÇO DE ATENDIMENTO AO
                                            BENEFICIÁRIO
                                        </b>{" "}
                                        - Ligue para 4007-2400 (Capitais e
                                        regiões metropolitanas) ou 0800 643 4300
                                        (Demais localidades)
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            )}
        </>
    );
};

export default Bloco2;
